const templatesTypes = {

  get: {
    request: "GET_TEMPLATE_REQUEST",
    success: "GET_TEMPLATE_SUCCESS",
    failure: "GET_TEMPLATE_FAILURE"
  },

  index: {
    request: "TEMPLATES_INDEX_REQUEST",
    success: "TEMPLATES_INDEX_SUCCESS",
    failure: "TEMPLATES_INDEX_FAILURE",
    select:  "TEMPLATES_INDEX_SELECT"
  },

  create: {
    init:    "CREATE_TEMPLATE_INIT",
    request: "CREATE_TEMPLATE_REQUEST",
    success: "CREATE_TEMPLATE_SUCCESS",
    failure: "CREATE_TEMPLATE_FAILURE"
  },

  destroy: {
    request: "DESTROY_TEMPLATE_REQUEST",
    success: "DESTROY_TEMPLATE_SUCCESS",
    failure: "DESTROY_TEMPLATE_FAILURE"
  },

  xlsx: {
    request: "TEMPLATES_XLSX_REQUEST",
    success: "TEMPLATES_XLSX_SUCCESS",
    failure: "TEMPLATES_XLSX_FAILURE"
  },

  update: {
    request: "UPDATE_TEMPLATE_REQUEST",
    success: "UPDATE_TEMPLATE_SUCCESS",
    failure: "UPDATE_TEMPLATE_FAILURE"
  },

  publish: {
    request: "PUBLISH_TEMPLATE_REQUEST",
    success: "PUBLISH_TEMPLATE_SUCCESS",
    failure: "PUBLISH_TEMPLATE_FAILURE",
    single:  "PUBLISH_SINGLE_TEMPLATE_SUCCESS"
  },

  set_errors: "SET_TEMPLATE_ERRORS",

  reset_template: "RESET_TEMPLATE",

  clear_template: "CLEAR_TEMPLATE",

}

export default templatesTypes



// WEBPACK FOOTER //
// ./src/js/constants/templatesTypes.js